/** Fuseau unique de la miellerie : La Réunion (UTC+4, pas d’heure d’été). */
export const TZ_REUNION = 'Indian/Reunion';
const OFFSET_HOURS_UTC = 4;

function pad2(n) {
  return String(n).padStart(2, '0');
}

export function partsHeureReunion(date = new Date()) {
  const dtf = new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ_REUNION,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  });
  const parts = {};
  for (const p of dtf.formatToParts(date)) {
    if (p.type !== 'literal') parts[p.type] = p.value;
  }
  return {
    year: Number(parts.year),
    month: Number(parts.month),
    day: Number(parts.day),
    hour: Number(parts.hour),
    minute: Number(parts.minute),
    second: Number(parts.second),
  };
}

export function todayISOReunion(date = new Date()) {
  const p = partsHeureReunion(date);
  return `${p.year}-${pad2(p.month)}-${pad2(p.day)}`;
}

export function nowMinutesReunion(date = new Date()) {
  const p = partsHeureReunion(date);
  return p.hour * 60 + p.minute;
}

export function formatHeureReunion(date = new Date()) {
  const p = partsHeureReunion(date);
  return `${pad2(p.hour)}:${pad2(p.minute)}`;
}

/**
 * Instant UTC correspondant à une date + heure murales à La Réunion.
 * @param {string} isoDate YYYY-MM-DD
 * @param {string} hhmm HH:mm
 */
export function reunionWallClockToDate(isoDate, hhmm, { extraDays = 0, endOfMinute = false } = {}) {
  if (!isoDate || hhmm == null || hhmm === '') return null;
  const [Y, M, D] = String(isoDate).split('T')[0].split('-').map(Number);
  const [hRaw, mRaw] = String(hhmm).split(':');
  const h = parseInt(hRaw, 10);
  const m = parseInt(mRaw, 10) || 0;
  if (![Y, M, D, h].every((n) => Number.isFinite(n))) return null;
  const s = endOfMinute ? 59 : 0;
  const ms = endOfMinute ? 999 : 0;
  return new Date(Date.UTC(Y, M - 1, D + extraDays, h - OFFSET_HOURS_UTC, m, s, ms));
}
